export const contratosList = {
  tradicional: { id: 'tradicional', label: 'Tradicional - contrato tipo 1', prev_id: 'contrato_1' },
  inmediato: { id: 'inmediato', label: 'Inmediato - contrato tipo 2', prev_id: 'contrato_2' }
};
